import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm, FormProvider } from "react-hook-form";
import { IClienteCompleto } from "../../../../../../Interfaces/Geral/Cliente/IClienteSimples";
import InformacoesEnderecoCard from "../../../InformacoesEndereco";
import { AtualizarClienteController } from "../../../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { ChangeEvent, useState } from "react";
import { useClientePage } from "../../../../../../Context/ClientePage";
import { useUserInfor } from "../../../../../../Context/User";
import { ListarPerfilTipoContaController } from "../../../../../../Controllers/Geral/CadastroEEditaTipoConta/CadastroEEditaTipoContaController";
import { ListarPerfilFinanceiroController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/PerfilFinanceiro/PerfilFinanceiroController";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../../Utils/OrSpinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface IDadosCadastraisClienteProps {
    Cliente?: IClienteCompleto;
}

interface IDadosCadastraisFormData {
    DS_NOME: string;
    DS_EMAIL: string;
    NR_CPF_CNPJ: string;
    NR_RG: number;
    DT_RG_EMISSAO: string;
    DS_SEXO: string;
    INFO_END: Array<{
        ID_CIDADE_ENDERECO?: number;
        ID_ESTADO_ENDERECO?: number;
        DS_BAIRRO_ENDERECO?: string;
        DS_LOGRADOURO_ENDERECO?: string;
        NR_ENDERECO_ENDERECO?: string;
        DS_COMPLEMENTO_ENDERECO?: string;
        NR_CEP_ENDERECO?: number;
    }>;
}

export default function EditarCliente(props: IDadosCadastraisClienteProps) {
    const formMethods = useForm<IDadosCadastraisFormData>();

    const { OrgInfor } = useUserInfor();

    const { update } = useClientePage();

    const [mostrarUAU, setmostrarUAU] = useState(false);
    const [atualizarDadosUAU, setAtualizarDadosUAU] = useState(false);

    const { value: lstPerfilFinanceiro, loading: lstPerfilFinanceiroLoading } =
        useAsyncEffect(() => ListarPerfilFinanceiroController(), []);

    const { value: lstPerfilTipoConta, loading: lstPerfilTipoContaLoading } =
        useAsyncEffect(() => ListarPerfilTipoContaController(), []);

    const Cliente: IClienteCompleto | undefined =
        mostrarUAU && props.Cliente?.DADOS_CLIENTE
            ? {
                  NR_CPF: Number(props.Cliente?.DADOS_CLIENTE?.cpf_pes),
                  DS_NOME: props.Cliente?.DADOS_CLIENTE?.nome_pes,
                  DS_EMAIL: props.Cliente?.DADOS_CLIENTE?.email_pes,
                  DT_NASCIMENTO: props.Cliente?.DADOS_CLIENTE?.dtnasc_pes,
                  DS_ESTADO_CIVIL: props.Cliente?.DADOS_CLIENTE?.estciv_pf,
                  NR_ENDERECO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.numend_pend,
                  DS_ESTADO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.uf_pend,
                  DS_CIDADE_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.cidade_pend,
                  DS_BAIRRO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.bairro_pend,
                  DS_LOGRADOURO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.endereco_pend,
                  DS_COMPLEMENTO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca
                          ?.complendereco_pend,
                  NR_ENDERECO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.numend_pend,
                  DS_ESTADO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.uf_pend,
                  DS_CIDADE_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.cidade_pend,
                  DS_BAIRRO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.bairro_pend,
                  DS_LOGRADOURO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.endereco_pend,
                  DS_COMPLEMENTO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega
                          ?.complendereco_pend,
              }
            : props.Cliente;

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setmostrarUAU(e.target.checked);
    }

    function handleDadosCadastraisFormSubmit(
        formData: IDadosCadastraisFormData
    ) {
        AtualizarClienteController(
            {
                ...formData,
                ID_CHAVE_ERP: props.Cliente?.ID_CHAVE_ERP,
                ID_CONTA: props.Cliente?.ID_CONTA,
                NR_CPF: Cliente?.NR_CPF,
                DS_EMAIL: formData.DS_EMAIL,
                ID_CIDADE_COBRANCA: formData.INFO_END[0].ID_CIDADE_ENDERECO,
                DS_BAIRRO_COBRANCA: formData.INFO_END[0].DS_BAIRRO_ENDERECO,
                DS_COMPLEMENTO_COBRANCA:
                    formData.INFO_END[0].DS_COMPLEMENTO_ENDERECO,
                NR_ENDERECO_COBRANCA: formData.INFO_END[0].NR_ENDERECO_ENDERECO,
                DS_LOGRADOURO_COBRANCA:
                    formData.INFO_END[0].DS_LOGRADOURO_ENDERECO,
                NR_CEP_COBRANCA: formData.INFO_END[0].NR_CEP_ENDERECO,
                ID_CIDADE_ENTREGA: formData.INFO_END[1].ID_CIDADE_ENDERECO,
                DS_BAIRRO_ENTREGA: formData.INFO_END[1].DS_BAIRRO_ENDERECO,
                DS_COMPLEMENTO_ENTREGA:
                    formData.INFO_END[1].DS_COMPLEMENTO_ENDERECO,
                NR_ENDERECO_ENTREGA:
                    formData.INFO_END[1].NR_ENDERECO_ENDERECO === "S/N"
                        ? "0"
                        : formData.INFO_END[1].NR_ENDERECO_ENDERECO,
                DS_LOGRADOURO_ENTREGA:
                    formData.INFO_END[1].DS_LOGRADOURO_ENDERECO,
                NR_CEP_ENTREGA: formData.INFO_END[1].NR_CEP_ENDERECO,
            },
            atualizarDadosUAU
        ).then(() => {
            update();
        });
    }
    return (
        <OrSpinner
            loading={lstPerfilFinanceiroLoading || lstPerfilTipoContaLoading}
            spinner="capys"
        >
            <FormProvider {...formMethods}>
                <form
                    onSubmit={formMethods.handleSubmit(
                        handleDadosCadastraisFormSubmit
                    )}
                >
                    <div className="d-flex g-3">
                        {props.Cliente?.DADOS_CLIENTE &&
                            OrgInfor.COD_ERP_INTEGRACAO === "UAU" && (
                                <div className="d-flex text-success align-items-center mr-2">
                                    <label htmlFor="mostrardadosUAUcheckboxparaoeditar">
                                        {" "}
                                        Mostrar Dados UAU
                                    </label>
                                    <input
                                        className="ml-2 mb-2 "
                                        type={"checkbox"}
                                        id={
                                            "mostrardadosUAUcheckboxparaoeditar"
                                        }
                                        onChange={handleChange}
                                        checked={mostrarUAU}
                                    />
                                </div>
                            )}

                        {props.Cliente?.DADOS_CLIENTE &&
                            OrgInfor.COD_ERP_INTEGRACAO === "UAU" && (
                                <div className="d-flex text-info align-items-center mr-2">
                                    <label htmlFor="atualizarDadosUAU">
                                        {" "}
                                        Atualizar Dados UAU
                                    </label>
                                    <input
                                        className="ml-2 mb-2 "
                                        type={"checkbox"}
                                        id={"atualizarDadosUAU"}
                                        onChange={(e) =>
                                            setAtualizarDadosUAU(
                                                e.target.checked
                                            )
                                        }
                                        checked={atualizarDadosUAU}
                                    />
                                </div>
                            )}
                    </div>
                    <div className="form-group row pt-2">
                        <div className="col-lg-6">
                            <div className="input-icon">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nome Cliente"
                                    name="DS_NOME"
                                    ref={formMethods.register({
                                        required: "Insira o nome do cliente",
                                    })}
                                    defaultValue={Cliente?.DS_NOME}
                                />
                                <span>
                                    <i className="flaticon2-sort-alphabetically icon-md"></i>
                                </span>
                            </div>
                        </div>
                        <div className="col-lg-6">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    Para editar o email, o campo "Atualizar Dados UAU" deve estar marcado.
                                </Tooltip>
                            }
                            placement="top"
                            trigger="hover"
                        >
                            {({ ref, ...triggerHandler }) => (
                                <div
                                    className="input-icon"
                                    ref={ref}
                                    {...triggerHandler}
                                >
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Email"
                                        name="DS_EMAIL"
                                        ref={formMethods.register()}
                                        defaultValue={Cliente?.DS_EMAIL}
                                        disabled={OrgInfor.COD_ERP_INTEGRACAO === "UAU" ? !atualizarDadosUAU : false}
                                    />
                                    <span>
                                        <i className="flaticon-multimedia icon-md"></i>
                                    </span>
                                </div>
                            )}
                        </OverlayTrigger>

                        </div>
                    </div>
                    <div className="form-group row pt-2">
                        <div className="col-lg-4">
                            <label>Tipo Cliente</label>
                            <select
                                className="form-control"
                                placeholder="Tipo Cliente"
                                name="ID_TIPO_CLIENTE"
                                ref={formMethods.register()}
                                defaultValue={
                                    Cliente?.tipoConta?.ID_PERFIL_TIPO_CONTA
                                }
                            >
                                <option></option>
                                {lstPerfilTipoConta?.map((perfilTipoConta) => (
                                    <option
                                        value={
                                            perfilTipoConta.ID_PERFIL_TIPO_CONTA
                                        }
                                    >
                                        {perfilTipoConta.DS_PERFIL_TIPO_CONTA}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-lg-4">
                            <label>Perfil Financeiro</label>
                            <select
                                // controller={ListarPerfilFinanceiroController}
                                // getDS={(p) => p.DS_PERFIL_FINANCEIRO_CONTA}
                                // getKeyValue={(p) =>
                                //     p.ID_PERFIL_FINANCEIRO_CONTA
                                // }
                                className="form-control"
                                placeholder="Perfil Financeiro"
                                name="ID_PERFIL_FINANCEIRO"
                                ref={formMethods.register()}
                                // control={formMethods.control}
                                defaultValue={
                                    Cliente?.perfilFinanceiro
                                        ?.ID_PERFIL_FINANCEIRO_CONTA
                                }
                            >
                                <option></option>
                                {lstPerfilFinanceiro?.map(
                                    (perfilFinanceiro) => (
                                        <option
                                            value={
                                                perfilFinanceiro.ID_PERFIL_FINANCEIRO_CONTA
                                            }
                                        >
                                            {
                                                perfilFinanceiro.DS_PERFIL_FINANCEIRO_CONTA
                                            }
                                        </option>
                                    )
                                )}
                            </select>
                        </div>
                        <div className="col-lg-4">
                            <label>Login Portal</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Login do portal"
                                name="DS_LOGIN_PORTAL"
                                ref={formMethods.register()}
                                defaultValue={Cliente?.DS_LOGIN_PORTAL}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-lg-3">
                            <label>Sexo</label>
                            <select
                                className="form-control"
                                name="DS_SEXO"
                                defaultValue={Cliente?.DS_SEXO}
                                ref={formMethods.register()}
                            >
                                <option>Masculino</option>
                                <option>Feminino</option>
                                <option>Outro</option>
                            </select>
                        </div>
                        <div className="col-lg-3">
                            <label>CPF / CNPJ</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="CPF | CNPJ"
                                name="NR_CPF_CNPJ"
                                ref={formMethods.register()}
                                defaultValue={Cliente?.NR_CPF}
                                disabled
                            />
                        </div>
                        <div className="col-lg-3">
                            <label>RG</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nº RG"
                                name="NR_RG"
                                ref={formMethods.register()}
                                defaultValue={Cliente?.NR_RG}
                            />
                        </div>
                        <div className="col-lg-3">
                            <label>Data de Emissão</label>
                            <input
                                type="date"
                                className="form-control"
                                placeholder="Data Emissão RG"
                                name="DT_RG_EMISSAO"
                                ref={formMethods.register()}
                                defaultValue={
                                    Cliente?.DT_RG_EMISSAO
                                        ? Cliente.DT_RG_EMISSAO.slice(0, 10)
                                        : ""
                                }
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-lg-3">
                            <label>Data de Nascimento</label>
                            <input
                                type="date"
                                className="form-control"
                                placeholder="Data Nascimento"
                                name="DT_NASCIMENTO"
                                ref={formMethods.register()}
                                defaultValue={
                                    Cliente?.DT_NASCIMENTO
                                        ? Cliente.DT_NASCIMENTO.slice(0, 10)
                                        : ""
                                }
                            />
                        </div>
                        <div className="col-lg-3">
                            <label>Receber cobrança</label>
                            <span className="switch switch-outline switch-icon switch-success">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={Cliente?.FL_RECEBER_COBRANCA}
                                        ref={formMethods.register()}
                                        name="FL_RECEBER_COBRANCA"
                                    />
                                    <span></span>
                                </label>
                            </span>
                        </div>
                    </div>
                    <ul className="nav nav-light-primary nav-bold nav-pills">
                        <li className="nav-item">
                            <a
                                className="nav-link active"
                                data-toggle="tab"
                                href="#EnderecoCobrancaModal"
                            >
                                <span className="nav-icon">
                                    <i className="flaticon2-chat-1"></i>
                                </span>
                                <span className="nav-text">
                                    Endereço de Cobrança
                                </span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                data-toggle="tab"
                                href="#EnderecoEntregaModal"
                            >
                                <span className="nav-icon">
                                    <i className="flaticon2-drop"></i>
                                </span>
                                <span className="nav-text">
                                    Endereço de Entrega
                                </span>
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content">
                        <div
                            className="tab-pane fade show active"
                            id="EnderecoCobrancaModal"
                            role="tabpanel"
                        >
                            <InformacoesEnderecoCard
                                formIndex={0}
                                ObjectInformacoesEndereco={{
                                    ID_CIDADE_ENDERECO:
                                        Cliente?.ID_CIDADE_COBRANCA,
                                    DS_BAIRRO_ENDERECO:
                                        Cliente?.DS_BAIRRO_COBRANCA,
                                    DS_COMPLEMENTO_ENDERECO:
                                        Cliente?.DS_COMPLEMENTO_COBRANCA,
                                    NR_ENDERECO_ENDERECO:
                                        Cliente?.NR_ENDERECO_COBRANCA,
                                    DS_LOGRADOURO_ENDERECO:
                                        Cliente?.DS_LOGRADOURO_COBRANCA,
                                    NR_CEP_ENDERECO: Cliente?.NR_CEP_COBRANCA,
                                }}
                            />
                        </div>
                        <div
                            className="tab-pane fade"
                            id="EnderecoEntregaModal"
                            role="tabpanel"
                        >
                            <InformacoesEnderecoCard
                                formIndex={1}
                                ObjectInformacoesEndereco={{
                                    ID_CIDADE_ENDERECO:
                                        Cliente?.ID_CIDADE_ENTREGA,
                                    DS_BAIRRO_ENDERECO:
                                        Cliente?.DS_BAIRRO_ENTREGA,
                                    DS_COMPLEMENTO_ENDERECO:
                                        Cliente?.DS_COMPLEMENTO_ENTREGA,
                                    NR_ENDERECO_ENDERECO:
                                        Cliente?.NR_ENDERECO_ENTREGA,
                                    DS_LOGRADOURO_ENDERECO:
                                        Cliente?.DS_LOGRADOURO_ENTREGA,
                                    NR_CEP_ENDERECO: Cliente?.NR_CEP_ENTREGA,
                                }}
                            />
                        </div>
                    </div>
                    <div className="card-footer d-flex justify-content-end">
                        <button
                            type="submit"
                            className="btn btn-outline-primary font-weight-bold d-flex justify-content-center"
                        >
                            <FontAwesomeIcon
                                icon={faSave}
                                size="lg"
                                className="mr-1"
                            />{" "}
                            Salvar
                        </button>
                    </div>
                </form>
            </FormProvider>
        </OrSpinner>
    );
}
